import { action, extendObservable } from 'mobx';
import PropTypes from 'prop-types';
import AsyncActionStore from './AsyncActionStore';
import FlagStore from './FlagStore';
import { apiCall } from '../API';
import InputStore from './InputStore';
import RadioButtonStore from './RadioButtonStore';

export const VERSION_TABS = {
    V1: 'v1',
    V2: 'v2',
};

export default class ReportingApiStore {
    static EMPTY_KEY = 'No API Key found';

    static PropType = PropTypes.shape({
        apiKey: InputStore.PropType.isRequired,
        createStatus: AsyncActionStore.PropType.isRequired,
        loadStatus: AsyncActionStore.PropType.isRequired,
        deleteStatus: AsyncActionStore.PropType.isRequired,
        create: PropTypes.func.isRequired,
        load: PropTypes.func.isRequired,
        delete: PropTypes.func.isRequired,
        deleteConfirmationModal: FlagStore.PropType.isRequired,
        confirmDelete: FlagStore.PropType.isRequired,
        activeTab: RadioButtonStore.PropType,
    });

    constructor(data = {}) {
        extendObservable(this, /** @class ReportingApiStore */ {
            apiLoad: apiCall('/console/reporting/getApiKey', { isUserAction: false }),
            apiCreate: apiCall('/console/reporting/createApiKey', { isUserAction: false }),
            apiDelete: apiCall('/console/reporting/deleteApiKey', { isUserAction: false }),
            apiKey: new InputStore({ value: ReportingApiStore.EMPTY_KEY }),
            createStatus: new AsyncActionStore(),
            loadStatus: new AsyncActionStore(),
            deleteStatus: new AsyncActionStore(),
            deleteConfirmationModal: new FlagStore(),
            confirmDelete: new FlagStore(),
            activeTab: new RadioButtonStore(VERSION_TABS.V2),
            get hasKey() {
                return this.apiKey.value !== ReportingApiStore.EMPTY_KEY && this.apiKey.value !== '';
            },
        }, data);
    }

    create = action(() => {
        if (!this.createStatus.isLoading) {
            this.createStatus.setLoading(this.apiCreate())
                .then((res) => {
                    this.apiKey.setValue(res && res.value ? res.value : ReportingApiStore.EMPTY_KEY);
                    return res;
                });
        }
        return this.createStatus.promise;
    });

    load = action(() => {
        if (!this.loadStatus.isLoading) {
            this.loadStatus.setLoading(this.apiLoad())
                .then((res) => {
                    this.apiKey.setValue(res && res.value ? res.value : ReportingApiStore.EMPTY_KEY);
                    return res;
                });
        }
        return this.loadStatus.promise;
    });

    delete = action(() => {
        if (!this.deleteStatus.isLoading) {
            this.deleteStatus.setLoading(this.apiDelete())
                .then((res) => {
                    this.apiKey.setValue(ReportingApiStore.EMPTY_KEY);
                    return res;
                });
        }
        return this.deleteStatus.promise;
    });

    onCloseConfirmModal =action(() => {
        this.confirmDelete.setFalse();
        this.deleteConfirmationModal.close();
    });
}
